import { areChartSymbolsEqual, chartSymbolKey } from '@/lib/tradingview/chart-symbol-identity'
import type { ChartSymbolIdentity } from '@/lib/tradingview/chart-symbol-identity'
import type { ChartCompareCommand, ChartCompareResult } from '@/state/chart-compare'
import type { Exchange } from '@/types/generated/common/types'

export function serializeChartSymbolKeys(keys: string[]) {
  return JSON.stringify([...new Set(keys)].sort())
}

export function deserializeChartSymbolKeys(value: string) {
  return new Set<string>(JSON.parse(value) as string[])
}

export function filterCompareSymbols(
  symbols: ChartSymbolIdentity[],
  _allowedExchanges: ReadonlySet<Exchange>,
  _activeInstrumentKeys: ReadonlySet<string>
) {
  const deduped = new Map<string, ChartSymbolIdentity>()
  symbols.forEach((identity) => deduped.set(chartSymbolKey(identity), identity))
  const valid = [...deduped.values()]

  // Temporarily bypass the connected-account exchange and active-instrument guards
  // while verifying which exchanges the TradingView datafeed can compare.
  // const valid = [...deduped.values()].filter(
  //   (identity) =>
  //     allowedExchanges.has(identity.exchange) &&
  //     activeInstrumentKeys.has(chartSymbolKey(identity))
  // )

  return { valid, skipped: deduped.size - valid.length }
}

export function shouldProcessCompareCommand(
  command: ChartCompareCommand | undefined,
  lastHandledRequestId: number | null,
  chartId: string
) {
  return Boolean(
    command &&
    command.requestId !== lastHandledRequestId &&
    command.targetChartIds.includes(chartId)
  )
}

export function shouldShowCompareSymbolLabels(studyNames: readonly string[]) {
  return studyNames.includes('Compare')
}

export function aggregateCompareResults(
  targetChartIds: string[],
  results: Record<string, ChartCompareResult> | undefined,
  validationSkipped = 0
) {
  const acknowledged = targetChartIds.filter((chartId) => Boolean(results?.[chartId]))
  return acknowledged.reduce(
    (total, chartId) => {
      const result = results?.[chartId]
      if (!result) return total
      total.created += result.created
      total.skipped += result.skipped
      total.failed += result.failed
      return total
    },
    {
      acknowledged: acknowledged.length,
      complete: acknowledged.length === targetChartIds.length,
      created: 0,
      skipped: validationSkipped,
      failed: 0,
    }
  )
}

export function shouldInitializeCompareScale(
  initialized: boolean,
  existingCompareCount: number,
  createdCount: number
) {
  return !initialized && existingCompareCount === 0 && createdCount > 0
}

export function shouldRemoveCompareStudy(
  identity: ChartSymbolIdentity | null,
  _allowedExchanges: ReadonlySet<Exchange>,
  primaryIdentity: ChartSymbolIdentity
) {
  // Temporarily keep studies from exchanges without a connected account.
  // return Boolean(
  //   identity &&
  //   (!allowedExchanges.has(identity.exchange) || areChartSymbolsEqual(identity, primaryIdentity))
  // )
  return Boolean(identity && areChartSymbolsEqual(identity, primaryIdentity))
}
